module.exports = __webpack_public_path__ + "static/img/preview-pink-no-progress-bar.d8873556.png";